<template>
  <q-page padding>
    <PageHeader>
      <template #title>
        Associar regra individual para {{ dados.nome }}</template
      >
    </PageHeader>

    <p class="q-ml-md text-h7 text-brand-5 text-weight-bold">
      Selecione a unidade e os grupos para criar uma regra
    </p>

    <div class="row col-2 q-ml-md q-mt-md">
      <lista-unidades-select v-model="unidadeSelect"></lista-unidades-select>
    </div>
    <div class="q-mb-md">
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        :columns="columns"
        title="Selecione o(s) Grupo(s)"
        selection="multiple"
        v-model:selected="selected"
        v-model:pagination="pagination"
        dense
        class="q-mt-md"
        row-key="name"
        hide-pagination
        hide-header
        grid
        @request="handleRequest"
      >
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtrar"
            type="text"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:item="props">
          <div
            class="q-pa-xs col-xs-12 col-sm-6 col-md-4 col-lg-3 grid-style-transition"
            :style="selected ? 'transform: scale(0.95);' : ''"
          >
            <q-card :class="selected ? 'bg-grey-2' : ''">
              <q-card-section>
                <q-radio
                  dense
                  v-model="selected"
                  :val="props.row.id"
                  :label="props.row.name"
                  @click="verProdutos(props.row.id)"
                />
              </q-card-section>
              <q-separator />
            </q-card>
          </div>
        </template>
        <template #body-cell-epi="props">
          <q-td>
            <q-btn v-if="props" round color="positive" icon="headphones" />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>

    <span class="q-table__title q-mt-md">Defina a nova regra </span>
    <div class="row q-mt-md">
      <div class="col-3 col-md-2 q-mt-sm q-ml-sm">
        <q-input
          dense
          outlined
          label="Prazo Mínimo (em dias)"
          v-model="regras.minimo"
          min="0"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
      <div class="col-md-2 col-2 q-mt-sm q-ml-sm">
        <q-input
          dense
          outlined
          label="Prazo Máximo (em dias)"
          :disable="regras.minimo == ''"
          v-model="regras.maximo"
          min="0"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
      <div class="col-md-2 col-2 q-mt-sm q-ml-sm">
        <q-input
          dense
          outlined
          label="Quantidade"
          v-model="regras.quantidade"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
      <div class="col-md-2 col-2 q-mt-sm q-ml-sm">
        <q-select
          :options="tipo"
          dense
          outlined
          label="Tipo de Controle"
          v-model="regras.controle"
          :rules="[(val) => val || 'Campo Obrigatório']"
        />
      </div>
      <div class="col-md-2 col-2 q-mt-sm q-ml-sm">
        <q-select
          :options="critico"
          dense
          outlined
          label="Critico"
          v-model="regras.critico"
          :rules="[(val) => val || 'Campo Obrigatório']"
        />
      </div>
      <div class="q-mt-sm q-ml-sm">
        <q-btn
          @click="criarRegra"
          color="positive"
          label="Criar Regra"
          class="q-ml-sm"
        />
      </div>
    </div>

    <div>
      <table-produtos-selecionados
        :id="idProdutos"
        :atualizar="getSecondTable"
        :contratoId="$store.state.org.unidadeData.id"
      />
    </div>

    <div>
      <table-grupo-assosiado></table-grupo-assosiado>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, onMounted, computed, watch } from "vue";
import TableProdutosSelecionados from "../../grupoProdutos/components/TableProdutosSelecionados.vue";
import { useRoute } from "vue-router";

import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import TableGrupoAssosiado from "../components/TableGrupoAssosiado.vue";
import PageHeader from "../../../../components/PageHeader.vue";
export default {
  components: {
    TableProdutosSelecionados,
    TableGrupoAssosiado,
    ListaUnidadesSelect,
    PageHeader,
  },
  props: ["unidades"],

  setup(props) {
    const store = useStore();
    const rows = ref([]);
    const quasar = useQuasar();
    const disable = ref(true);
    const unidade = ref(store.state.org.unidadeData.id || "");
    const filtrar = ref("");
    const selected = ref([]);
    const idProdutos = ref("");
    const route = useRoute();
    const dados = JSON.parse(route.params.id);
    const getSecondTable = ref(0);
    const unidadeSelect = ref();
    const atualizar = ref(0);
    const regras = ref({
      minimo: "",
      maximo: "",
      quantidade: "",
      controle: "EMAIL E STATUS TROCA (WEB)",
      critico: "Não",
    });

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 15,
    });
    const getDados = async (page = 0, rowsPerPage = 8) => {
      disable.value = true;

      if (!unidade.value) {
        unidade.value = store.state.org.unidadeData.id;
      }

      if (!unidade.value) {
        disable.value = false;
        rows.value = [];
        pagination.value.rowsNumber = 0;
        return;
      }

      try {
        let response = await store.dispatch("grupoProdutos/listarGrupos", {
          unidade: unidade.value,
          page,
          per_page: rowsPerPage,
          search: filtrar.value,
        });

        rows.value = response.data.results.data;
        pagination.value.page = response.data.results.current_page;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;

        disable.value = false;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const criarRegra = async () => {
      if (selected.value.length == 0) {
        quasar.notify({
          message: "Selecione um grupo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        await store.dispatch("user/adicionarRegraGrupo", {
          group_id: selected.value,
          minimum_days: regras.value.minimo,
          maximum_days: regras.value.maximo,
          amount: regras.value.quantidade,
          control_types:
            regras.value.controle == "EMAIL E STATUS TROCA (WEB)"
              ? "ambos"
              : regras.value.controle.value,

          user_id: dados.id,
          critico:
            regras.value.critico == "Não" ? 0 : regras.value.critico.value,
        });

        quasar.notify({
          message: "Regra adicionada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        atualizar.value++;
      } catch (error) {
        quasar.notify({
          message:
            "Erro a o definir regra preencha todos os dados ou selecione um grupo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const verProdutos = async (id) => {
      idProdutos.value = id;
      getSecondTable.value++;
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filtrar.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => unidadeSelect.value,
      (newValue) => {
        if (newValue && newValue.id) {
          unidade.value = newValue.id;
          getDados();
        }
      }
    );

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        unidade.value = store.state.org.unidadeData.id;
        getDados();
      }
    );

    watch([() => regras.value.minimo, () => regras.value.maximo], () => {
      if (Number(regras.value.minimo) > Number(regras.value.maximo)) {
        regras.value.maximo = +regras.value.minimo + 1;
      }
    });

    watch(
      () => props.unidades,
      () => {
        unidade.value = "";
        getDados();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidadeSelect.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);
    return {
      rows,
      columns,
      getDados,
      unidade,
      pagination,
      handleRequest,
      disable,
      filtrar,
      regras,
      criarRegra,
      verProdutos,
      idProdutos,
      unidadeSelect,
      getSecondTable,
      dados,
      atualizar,
      tipo: [
        {
          label: "EMAIL E STATUS TROCA (WEB)",
          value: "ambos",
        },
        {
          label: "NENHUM",
          value: "nenhum",
        },
        {
          label: "SOMENTE EMAIL",
          value: "email",
        },
        {
          label: "SOMENTE STATUS TROCA (WEB)",
          value: "farol",
        },
      ],
      critico: [
        {
          label: "SIM",
          value: "1",
        },
        {
          label: "NÃO",
          value: "0",
        },
      ],
      selected,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style lang="sass">
.grid-style-transition
  transition: transform .28s, background-color .28s
</style>

<style>
.align {
  align-items: center;
}

.pointer {
  cursor: pointer;
}
</style>
